import './workout-start-training.css';
import MusicPlayer from "../../components/Music/Music";
import {musicTracks} from "../../assets/musicTracks/MusicTracks";
import {useNavigate} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import Routes from "../../assets/RoutesToPages/Routes";
import {WorkoutContent} from "../../assets/WorkoutContent";
import Lottie from "react-lottie";
import TimerExerciseDemo from "../../components/TimerExerciseDemo/TimerExerciseDemo";
import TimerExercise from "../../components/TimerExercise/TimerExercise";
import TimerExerciseNoDuration from "../../components/TimerExerciseNoDuration/TimerExerciseNoDuration";
import {ReactComponent as WorkoutTrainingContentLogo} from './workout-start-training-img/main-img.svg';
import {ReactComponent as RestBreakImg} from './workout-start-training-img/rest-break-avocado.svg';


const WorkoutStartTraining = () => {
  const navigate = useNavigate();
  const localWorkoutSetupData = JSON.parse(localStorage.getItem('workoutSetupData'));
  const [exerciseId, setExerciseId] = useState(1);
  const [exerciseCycleSet, setExerciseCycleSet] = useState(1);
  const specifiedExerciseData = WorkoutContent['exercise-type']
    [localWorkoutSetupData['exerciseName']][localWorkoutSetupData.character]
    [localWorkoutSetupData.difficulty];
  const specifiedExerciseAmount = specifiedExerciseData.length;
  const specifiedExerciseDuration = specifiedExerciseData.map(item => {
    if ((item.id === Math.ceil(exerciseId / 3)) && (item.subtitle.includes('sec'))) {
      return Number(item.subtitle.replace(/\D/g, ''));
    } else if ((item.id === Math.ceil(exerciseId / 3)) && (item.subtitle.includes('min'))) {
      return item.subtitle.replace(/\D/g, '') * 60;
    }
  }).filter(item => item !== undefined)[0];
  const specifiedExerciseQuantity = specifiedExerciseData.map(item => {
    return (item.id === Math.ceil(exerciseId / 3)) &&
    ((item.subtitle.includes('x'))) ? item.subtitle.replace(/\D/g, '') : '';
  }).filter(item => item !== '')[0];
  const lottieExerciseRef = useRef(null);
  const typeExercisesContainerRef = useRef(null);
  const timerFadeIn = useRef(null);
  const [isPaused, setIsPaused] = useState(false);


  const handleStartNextTraining = () => {
    setIsPaused(false);
    setExerciseId(prev => prev + 1);
  }


  const handlePrevTraining = () => {
    setIsPaused(false);
    setExerciseId(prev => prev - 1);
    return exerciseCycleSet === 1 ? setExerciseId(prev => prev - 1) :
      exerciseCycleSet === 2 ? setExerciseId(prev => prev - 2) : null;
  }


  useEffect(() => {
    if (exerciseId === (specifiedExerciseAmount * 3)) {
      navigate(Routes.workoutFeedback);
    }

    if ((exerciseId % 3) !== 0) {
      setExerciseCycleSet(exerciseId % 3);
    } else {
      setExerciseCycleSet(0);
    }
  }, [exerciseId]);


  useEffect(() => {
    if (typeExercisesContainerRef.current) {
      typeExercisesContainerRef.current.classList.add('exercise-control-panel--fade');

      timerFadeIn.current = setTimeout(() => {
        typeExercisesContainerRef.current.classList.remove('exercise-control-panel--fade');
      }, 305)
    }

    return () => {
      clearTimeout(timerFadeIn.current)
    }
  }, [exerciseCycleSet, exerciseId]);


  return (
    <div className='workout-training-container'>
      <WorkoutTrainingContentLogo className="workout-training-content-logo"
                                  width='131'
                                  height='134'/>
      <p className='workout-training__title'>{[localWorkoutSetupData['exerciseNameLocal']]}</p>
      <div className='workout-training-content'>
        <div className='workout-navigation__start-training'>
          <img className='workout-navigation__start-training-arrow'
               onClick={() => navigate(-1)}
               loading="lazy"
               src={require("./workout-start-training-img/back_arrow.svg").default}
               width='24'
               height='24'
               alt="image arrow left">
          </img>
          <p className='current-exercise-title'>{
            specifiedExerciseData.map(item => {
              let currentExerciseTitle = '';

              if (String(item.id).length < 2) {
                currentExerciseTitle = item.title.slice(3);
              } else {
                currentExerciseTitle = item.title.slice(4);
              }

              return item.id === Math.ceil(exerciseId / 3) ? currentExerciseTitle : '';
            })}
          </p>
          {<MusicPlayer tracks={musicTracks}/>}
        </div>
        <div
          ref={typeExercisesContainerRef}
          className='type-exercises-container'>
          {specifiedExerciseData.map(exerciseType => {
              return exerciseType.id === Math.ceil(exerciseId / 3) ?
                <div key={exerciseType.id}
                     className={`workout-type-training ${exerciseCycleSet === 0 ? 'no-max-height' : ''}`}>
                  {exerciseCycleSet !== 0 ?
                    <Lottie ref={lottieExerciseRef}
                            loading="lazy"
                            options={{
                              loop: true,
                              autoplay: true,
                              animationData: exerciseType.image,
                              rendererSettings: {
                                preserveAspectRatio: 'xMidYMid meet',
                              }
                            }}
                            isClickToPauseDisabled={true}
                            isPaused={isPaused}
                            height={260}
                    />
                    :
                    <div className='rest-break-container'>
                      <p className='rest-break-recommendation'>
                        Before starting the next exercise, <br/>
                        we recommend you drink water <br/>
                        and rest for a while.
                      </p>
                      <RestBreakImg className='rest-break-recommendation-img'/>
                    </div>}
                </div> : null;
            }
          )}
          <div className="exercise-control-panel-container">
            <p className={`exercise-title-stage ${exerciseCycleSet === 1 || exerciseCycleSet === 2 ?
              'exercise-title-stage-visible' : ''}`}>
              {exerciseCycleSet === 1 ? 'Get ready' : 'GO!'}
            </p>
            <div className='exercise-control-panel'>
              <div onClick={handlePrevTraining}
                   className={`exercise-btn ${exerciseId <= 2 ? 'exercise-btn--disabled' : ''}`}>
                <img loading="lazy"
                     src={exerciseId <= 2 ?
                       require('./workout-start-training-img/arrow-previous-disabled.svg').default
                       :
                       require('./workout-start-training-img/arrow-previous-active.svg').default}
                     width='40'
                     height='40'
                     alt="switch previous step"/>
              </div>
              {specifiedExerciseData.map(exerciseType => {
                  if (exerciseType.id === Math.ceil(exerciseId / 3)) {
                    return exerciseId % 3 === 1 ?
                      <TimerExerciseDemo
                        handleStartNextStep={setExerciseId}
                        initialTime={10}
                        key={exerciseType.id}/>
                      : (exerciseCycleSet === 2 && specifiedExerciseDuration !== undefined) ?
                        <TimerExercise
                          key={exerciseType.id}
                          handleStartNextStep={setExerciseId}
                          handleMoveExerciseAnimation={setIsPaused}
                          exerciseDuration={specifiedExerciseDuration}
                        />
                        : (exerciseCycleSet === 2 && specifiedExerciseQuantity !== undefined) ?
                          <TimerExerciseNoDuration
                            key={exerciseType.id}
                            handleMoveExerciseAnimation={setIsPaused}/>
                          : exerciseCycleSet === 0 ?
                            <TimerExerciseDemo initialTime={30}
                                               handleStartNextStep={setExerciseId}
                                               key={exerciseType.id}/>
                            : null
                  }
                }
              )}
              <div onClick={handleStartNextTraining}
                   className='exercise-btn'>
                <img loading="lazy"
                     src={require('./workout-start-training-img/arrow-next.svg').default}
                     width='40'
                     height='40'
                     alt="switch next step"/>
              </div>
            </div>
            <p className={`exercise-repeat-quantity ${specifiedExerciseQuantity && exerciseCycleSet === 2
              ? 'exercise-repeat-shown' : ''}`}>{specifiedExerciseQuantity} times</p>
          </div>

        </div>
      </div>
    </div>
  )
}

export default WorkoutStartTraining;